import { Component, OnInit } from '@angular/core';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { URL_DOCS } from 'src/app/config/config';
import { FormsModule } from '@angular/forms';
import { da } from 'date-fns/locale';
declare var $: any;

@Component({
  selector: 'app-admin-tips',
  templateUrl: './admin-tips.component.html',
  styleUrls: ['./admin-tips.component.css']
})
export class AdminTipsComponent implements OnInit {

  URL_DOCS = URL_DOCS;
  tipsList: any = [];
  tipSelected: any = [];
  isEdit = false;
  isLoading = false;
  modalActivo: 'crear' | 'editar' | null = null;



  nuevoTip = {
    titulo: '',
    descripcion: '',
    fechaFrom: '',
    fechaTo: '',
    numero: null,
    con_info_type: 1,
  };

  numeros: number[] = Array.from({ length: 10 }, (_, i) => i);
  numeroSeleccionado: number | null = null;


  errores: { [key: string]: boolean } = {};


  constructor(
    public mantenedorService: MantenedorService
  ) {}

  ngOnInit(): void {
    this.getTips();
  }

  private validarCamposObligatorios(campos: string[], datos: any): boolean {
    this.errores = {};
    let valido = true;

    for (const campo of campos) {
      const valor = datos[campo];

      if (!valor || valor.toString().trim() === '') {
        this.errores[campo] = true;
        valido = false;
      }
    }

    if (!valido) {
      setTimeout(() => {
        this.errores = {};
      }, 5000);
    }

    return valido;
  }

  getTips() {
    this.isLoading = true;
    let conInfoType = 1; //Tips
    this.mantenedorService.getTips(conInfoType).then((data: any) => {
      this.tipsList = data.data
    })
    .catch((error: any) => {console.log(error)})
    .finally(() => { this.isLoading = false; });
  }

  clickTips(tips) {
    this.tipSelected = tips;
  }
  editTip() {
    this.isEdit = true;
    this.modalActivo = 'editar';
  }
  cancelEditTip() {
    this.isEdit = false;
  }

  saveTip() {
    //console.log('Tips a guardar:', this.nuevoTip); // Para depurar

    const camposRequeridos = ['titulo', 'descripcion'];
    if (!this.validarCamposObligatorios(camposRequeridos, this.nuevoTip)) {
      return;
    }
    
    this.isLoading = true;
    this.modalActivo = 'crear';

    this.mantenedorService.saveTips(this.nuevoTip).then((res: any) => {
      // console.log('Correcto');

      this.nuevoTip = { titulo: '', descripcion: '', fechaFrom: '', fechaTo: '', numero: null, con_info_type: 1 };
      this.isEdit = false;
      this.isLoading = false;
      this.modalActivo = null;
      
      
      // ✅ Cierra el modal con jQuery
      ($('#crearTips') as any).modal('hide');
      
      this.getTips();

    }).catch((error: any) => {
      console.log(error);
    });
  }

  updateTip() {
    //console.log('Tips a modificar:', this.tipSelected); // Para depurar

    const camposRequeridos = ['con_info_title', 'con_info_description'];
    if (!this.validarCamposObligatorios(camposRequeridos, this.tipSelected)) {
      return;
    }

    this.isLoading = true;

    this.mantenedorService.updateTips(this.tipSelected).then((res: any) => {
      // console.log('Correcto');
      
      this.isEdit = false;
      
      this.isLoading = false;
      this.modalActivo = null;
      
      ($('#visualizarTips') as any).modal('hide');
      
      this.getTips();

    }).catch((error: any) => {
      console.log(error);
    });
  }

}
